import Svg, { Rect } from "react-native-svg"

interface TalkIconProps {
  size?: number
  color?: string
}

/**
 * TalkIcon — waveform / sound-bars icon used for the Talk button.
 * Five rounded vertical bars of varying heights, centred vertically,
 * approximating the provided brand asset.
 */
export function TalkIcon({ size = 24, color = "#FFFFFF" }: TalkIconProps) {
  // Bar definitions: [x, y, height] — viewBox is 24×24
  // Bars are 3 px wide, spaced 5 px apart (centre-to-centre), rx=1.5 for rounded ends.
  const bars: [number, number, number][] = [
    [0.5, 9, 6],   // short
    [5.5, 2.5, 19], // tallest
    [10.5, 6, 12],  // medium
    [15.5, 7.5, 9], // short-medium
    [20.5, 3, 18],  // tall
  ]

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {bars.map(([x, y, h], i) => (
        <Rect key={i} x={x} y={y} width="3" height={h} rx="1.5" fill={color} />
      ))}
    </Svg>
  )
}
